import { Input, Icon } from 'ui/components/primitives';

import { SEARCH_INPUT_CONST, type SearchInputProps } from './SearchInput.d';
import { useSearch } from './SearchInput.hooks';
import { Search } from './SearchInput.styles';

const SearchInputBase = ({
  autoFocus,
  ghost,
  listId,
  onChangeSearch,
  onClear,
  onSearchClick,
  type = 'search',
  ...props
}: SearchInputProps) => {
  const { handleChange, handleClear, searchValue } = useSearch({
    onChangeSearch,
    onClear,
    type,
  });

  return (
    <Search.Form onSubmit={onSearchClick}>
      <Search.FocusTarget disabled={!autoFocus}>
        <Input
          autoFocus={autoFocus}
          data-ghost={ghost}
          data-testid={SEARCH_INPUT_CONST.TEST_ID}
          list={listId}
          name="q"
          onChange={handleChange}
          renderPrefix={
            <Search.ButtonSearch aria-label="pesquisar" size="small">
              <Icon.Search size="m" />
            </Search.ButtonSearch>
          }
          renderSuffix={
            searchValue && (
              <Search.ButtonClear
                aria-label="limpar pesquisa"
                data-testid="clear-button"
                onClick={handleClear}
                size="small"
              >
                <Icon.Close size="m" />
              </Search.ButtonClear>
            )
          }
          type={type}
          value={searchValue}
          {...props}
        />
      </Search.FocusTarget>
    </Search.Form>
  );
};

export default SearchInputBase;
